<script>
  import { _ } from 'svelte-i18n'
  import { previews_are_highlighted } from '../../stores'
  import InsertFeatureUpgrade from './templates/Upgrade.svelte'
  import Insert from '../../elements/Insert.svelte'

  export let insert_position
  export let inbetween_counter

</script>

<!-- Before Preview -->
{#if insert_position === 'before_previews'}
  {#if !$previews_are_highlighted}
    <Insert {insert_position}>
      <span slot="toptitle">
        { $_('inserts.highlight.topTitle') }
      </span>
      <span slot="title">
        {@html $_('inserts.highlight.titleBefore') }
      </span>    
      <span slot="text">
        {@html $_('inserts.highlight.textBefore') }
      </span>
    </Insert>
  {/if}
{/if}

{#if insert_position === 'between_previews'}
  <!-- Between Previews 2 -->
  {#if inbetween_counter === 2}
    <InsertFeatureUpgrade feature="highlight"/>
  {/if}  
{/if}